import header from "./auszahlung-baufinanzierung.webp";
import section1 from "./prospekte.webp";
import section2 from "./bauplan.jpg";
import section3 from "./details-einer-baufinanzierung-werden-besprochen.jpg";
import section4 from "./haus-wird-finanziert.jpg";
import section5 from "./bauplan-wird-diskutiert.jpg";
import section6 from "./hausschluessel.jpg";
import section7 from "./grundriss-mit-sigantur-eines-architekten.webp";
import section8 from "./papiere-werden-zerrissen.jpg";
import section9 from "./bafinanzierung-wird-unterzeichnet.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
